import type { DemoVideo } from './videoDemo'

type VideoCopy = Pick<DemoVideo, 'title' | 'type' | 'context'>

const englishVideoCopy: Record<string, VideoCopy> = {
  'hero-city': {
    title: 'City Brand Film',
    type: 'Cinematic Landscape',
    context: 'Homepage brand hero',
  },
  'creative-rider': {
    title: 'Neon Motion Portrait',
    type: 'AI Visual Reference',
    context: 'Creative video story',
  },
  'enterprise-robot': {
    title: 'Smart Manufacturing Film',
    type: 'Corporate Story',
    context: 'Industrial business case',
  },
  'product-skincare': {
    title: 'Skincare Product Demo',
    type: 'Product Video',
    context: 'Consumer brand story',
  },
  'product-studio': {
    title: 'Product Video Workshop',
    type: 'Course Preview',
    context: 'Hands-on training footage',
  },
  'course-presentation': {
    title: 'Brand Content Breakdown',
    type: 'Training Course',
    context: 'Instructor and team session',
  },
  'vertical-urban': {
    title: 'Vertical Character Story',
    type: 'People-led Short',
    context: '9:16 social video feed',
  },
  'vertical-beauty': {
    title: 'Vertical Beauty Story',
    type: 'Short-form Marketing',
    context: '9:16 product presentation',
  },
  'square-product-studio': {
    title: 'Square Product Workshop',
    type: '1:1 Video Story',
    context: 'Square content feed',
  },
}

export const translateDemoVideo = (video: DemoVideo, english: boolean): DemoVideo => {
  if (!english) return video
  const translated = englishVideoCopy[video.id]
  return translated ? { ...video, ...translated } : video
}
